// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eBKOr","col":"styles_col__3i5Pt"};